import { FC } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import { RouterUtils, useNavigate } from 'application/providers/RouterProvider';

import { usePointsGroupDeleteMutation } from '@shared/api/graphql/generated';
import { NOTIFICATION_DEFAULT_ERROR_MESSAGE, useNotificationContext } from 'application/providers/NotificationProvider';

import { IdParamValues } from 'application/pages/PointsGroupsPage';
import { POINTS_GROUPS_PAGE_PATH } from 'application/consts';
import styles from './index.module.scss';
import { TEXTS } from './texts';

export const RemovePointsGroupModal: FC<ModalProps[ModalTypes.REMOVE_POINTS_GROUP]> = ({ devicesGroupId, close }) => {
  const navigate = useNavigate();

  const notification = useNotificationContext();

  const [mutate, mutationResult] = usePointsGroupDeleteMutation();

  const onSave = async () => {
    if (devicesGroupId) {
      try {
        const ok = await mutate({ variables: { input: { devicesGroupId } }, refetchQueries: ['pointsGroups'] });

        if (ok) {
          notification.showInfoNotification({
            children: TEXTS.NOTIFICATION_SUCCESS_TEXT,
          });

          navigate(RouterUtils.generatePath(POINTS_GROUPS_PAGE_PATH, { id: IdParamValues.ALL }));

          close();
        } else {
          throw new Error();
        }
      } catch (e: unknown) {
        notification.showErrorNotification({
          children: NOTIFICATION_DEFAULT_ERROR_MESSAGE,
        });
      }
    }
  };

  return (
    <ModalScreen
      title={TEXTS.TITLE}
      titlePlacement="left"
      hideCloseButton
      onClose={close}
      className={styles.modal}
      actionButtons={[
        <Button
          key="button_confirm_points_group_modal"
          elementId="button_confirm_points_group_modal"
          type={ButtonType.PRIMARY}
          onClick={onSave}
          isLoading={mutationResult.loading}>
          {TEXTS.SAVE_BUTTON_TEXT}
        </Button>,
        <Button
          key="button_cancel_points_group_modal"
          elementId="button_cancel_points_group_modal"
          type={ButtonType.SECONDARY}
          onClick={() => close()}
          isDisabled={mutationResult.loading}>
          {TEXTS.CANCEL}
        </Button>,
      ]}>
      <div className={styles.description}>{TEXTS.DESCRIPTION}</div>
    </ModalScreen>
  );
};
